import { render, staticRenderFns } from "./PageTagList.vue?vue&type=template&id=4ded3691&scoped=true&"
import script from "./PageTagList.vue?vue&type=script&lang=js&"
export * from "./PageTagList.vue?vue&type=script&lang=js&"
import style0 from "./PageTagList.vue?vue&type=style&index=0&id=4ded3691&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ded3691",
  null
  
)

export default component.exports